export const globalScripts = () => {};
export const globalStyles = ".src-ui-kit{margin:auto}";
